var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6547 14.3125C11.4086 14.5586 11.4086 14.9688 11.6547 15.2148L16.9594 20.5469C17.2328 20.793 17.643 20.793 17.8891 20.5469L18.518 19.918C18.7641 19.6719 18.7641 19.2617 18.518 18.9883L14.307 14.75L18.518 10.5391C18.7641 10.2656 18.7641 9.85547 18.518 9.60938L17.8891 8.98047C17.643 8.73438 17.2328 8.73438 16.9594 8.98047L11.6547 14.3125Z",
    fill: "#761C33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.a422cd7fd0a879d95f9bfd60eaf86d5d.svg";
export { ForwardRef as ReactComponent };